define('uikit/modules/tutorial',['require','exports','module','backbone','underscore','marionette','jquery','../extra/canvas','../mixins/component.mixin','templates','../definitions/modules/transition'],function(require, exports, module){
  var Backbone = require('backbone');
  var _ = require('underscore');
  var Mn = require('marionette');
  var $ = require('jquery');
  var CanvasUtil = require('../extra/canvas');
  var ComponentMixin = require('../mixins/component.mixin');
  var Templates = require('templates');
  require('../definitions/modules/transition');

  var STEP_DEFINITION = {
    spotlight : null,
    arrows    : null,
    model     : null,
    childView : null
  };

 var Tutorial = Mn.ItemView.extend(ComponentMixin).extend({

  template: Templates.App['tutorial'],

  className: 'ui tutorial',

  options: {
    activeIndex      : -1,
    container        : 'body',
    activeView       : null,
    visible          : false,
    spotlightPadding : 0,
    opacity          : 0.5
  },

  forceUpdate: { container: true, opacity: true },

  ui: {
    fullSpotlight   : '.spotlight .full',
    leftSpotlight   : '.spotlight .left',
    rightSpotlight  : '.spotlight .right',
    topSpotlight    : '.spotlight .top',
    bottomSpotlight : '.spotlight .bottom',
    content         : '.content',
    arrowContainer  : '.arrows',
    canvas          : '.arrows canvas'
  },

  triggers: {
    'click': 'press',
    'mousedown': 'press'
  },

  initialize: function() {
    ComponentMixin.initialize.apply(this, arguments);
    this.steps = [];

    this.listenTo(this, 'change:activeIndex', function(view, value, prev) {
      if (value == 0 && prev == -1) {
        this.triggerMethod('start');
      }
      if (value > prev) {
        this.triggerMethod('next:step');
      } else if (value < prev) {
        this.triggerMethod('previous:step');
      }
    });
  },

  onFirstRender: function() {
    var refresh   = _.debounce(function() {
          this.refreshStep();
        }),
        container = $(this.container),
        self      = this;

    this.listenTo(this, 'change:activeIndex', refresh);
    this.listenTo(this, 'change:visible', refresh);
    this.listenTo(this, 'change:spotlightPadding', this.updateSpotlight);
    this.refreshStep();
    this.$el
        .appendTo(container);

    $(window)
        .on('resize.tutorial', _.debounce(function() {
          self.triggerMethod('resize');
        }))

    this.once('before:destroy', function() {
      $(window).off('resize.tutorial');
    });

    this.triggerMethod('show');
  },

  onResize: function() {
    var self = this;
    this.applyTutorialHeight();
    this.applyCanvasHeight();
    this.updateSpotlight();
    _.defer(function() {
      self.updateArrows({ transition: false });
    })
  },

  onRender: function() {
    if (this.painting) {
      this.painting.stop();
    }
    this.painting = new CanvasUtil.Painting(this.ui.canvas.get(0));
    this.applyCanvasHeight();
  },

  applyTutorialHeight: function() {
    this.$el.css('height', $(this.container).get(0).scrollHeight);
  },

  applyCanvasHeight: function() {
    var container = this.ui.arrowContainer[0],
        canvas    = this.ui.canvas;

    canvas.attr('height', container.offsetHeight + 'px').attr('width', container.offsetWidth + 'px');
  },

  onStart: function() {
    if (!this.isRendered) {
      this.render();
    }
    this.visible = true;
  },

  onFinish: function() {
    this.visible = false;
    this.activeIndex = -1;
  },

  hasNext: function() {
    return this.activeIndex < this.steps.length-1;
  },

  hasPrevious: function() {
    return this.activeIndex > 0;
  },

  isLast: function() {
    return this.activeIndex === this.steps.length-1;
  },

  refreshStep: function() {
    var step            = null,
        self            = this,
        previousContent = this._previousContent,
        previousIndex   = this._previousIndex == null ? -1 : this._previousIndex,
        painting        = this.painting,
        content         = null,
        ChildView       = null;

    this.painting.empty();

    if (previousContent) {
      // previousContent.remove();
      previousContent
          .transition('fade down', function() {
            previousContent.remove();
          })
    }

    this._previousIndex   = this.activeIndex;
    this._previousContent = null;

    if (!this.visible) { return; }

    if (this.activeView) {
      this.activeView.destroy();
      this.activeView = null;
    }

    var step = this.steps[this.activeIndex];

    this.applyTutorialHeight();
    this.applyCanvasHeight();

    if (!step) {
      this.triggerMethod('finish');
      return;
    }

    if (_.isFunction(step.onBeforeActive)) {
      var direction = previousIndex > this.activeIndex ? -1 : 1
      step.onBeforeActive.call(this, step, direction);
    }


    content = $(document.createElement('div')).appendTo(this.ui.content);
    this._previousContent = content;
    content
        .addClass('step')
        .addClass('centered');


    ChildView = step.childView;

    if (ChildView) {
      this.activeView = new ChildView(_.extend({}, { model: step.model, tutorial: this }, Mn._getValue(step.childViewOptions, this)));
    }

    if (this.activeView) {
      content.append(this.activeView.$el);
      this.activeView.render();
    }

    if (step.updateArrows !== false) {
      _.defer(function() {
        self.updateArrows();
      });
    }

    if (step.updateSpotlight !== false) {
      self.updateSpotlight();
    }

    painting.start();

    if (_.isFunction(step.onActive)) {
      var direction = previousIndex > this.activeIndex ? -1 : 1
      step.onActive.call(this, direction);
    }

    return this;
  },

  bounds: function() {
    return {
      height : this.$el.height(),
      width  : this.$el.width()
    }
  },

  positionActiveView: function(step, target) {
    var activeView       = this.activeView,
        activeViewBounds = { width: activeView.$el.outerWidth(), height: activeView.$el.outerHeight() },
        bounds           = this.bounds(),
        leftSide         = target.x < bounds.width/2,
        content          = activeView.$el.parent(),
        offset           = _.extend({ top: 0, left: 0 }, step.childViewOffset),
        position         = { x: target.x + offset.left + (leftSide ? 0 : -activeViewBounds.width), y: target.y + offset.top, width: activeViewBounds.width, height: activeViewBounds.height };

    var container = $(this.container);

    if (this._previousContainerMinHeight == null) {
      this._previousContainerMinHeight = container.css('min-height');
    } else {
      container.css('min-height', this._previousContainerMinHeight);
    }

    if (!step.childViewOffset) {
      position.x = activeView.$el.offset().left;
      position.y = activeView.$el.offset().top;
      return position;
    }

    if (position.y + position.height > (step.isFixed ? container.height() : container.get(0).scrollHeight)) {
      if (step.isFixed) {
        position.y = container.height() - position.height - 10;
      } else {
        container.css('min-height', (content.y + content.height) + 'px');
      }
    } else if (position.x < 0) {
      position.x = 10;
    }

    if (position.x + position.width > container.width()) {
      position.x = container.width() - position.width - 10;
    }

    content
        .removeClass('centered')
        .css('position', 'absolute')
        .css('left', position.x + 'px')
        .css('top', position.y + 'px');

    return position
  },

  createArrow: function(target, start, bend) {
    var middlePoint   = CanvasUtil.Point.movePointByAngle(start, CanvasUtil.Point.distance(start, target)/2, CanvasUtil.Point.angleBetweenPoints(start, target))
        controlPoint  = CanvasUtil.Point.rotatePointAboutPoint(middlePoint, start, bend),
        a             = new CanvasUtil.Arrow(new CanvasUtil.Point(start.x, start.y), controlPoint, new CanvasUtil.Point(target.x, target.y)),
        factor        = (Math.random() * 5) + 10;

    a.body.width = function(t) {
      return (-factor*(Math.pow(t, 2))) + (factor * t) + 2;
    };
    a.arrow.width = function(t) {
      return (t * 5) + 2;
    };
    return a;
  },

  resolveArrowTarget: function(arrow) {
    var target         = { x: 0, y:0 },
        positionRegExp = /(\w+)([+-]\d+)?/,
        offset         = null,
        step           = this.steps[this.activeIndex],
        position       = null;

    arrow = _.extend({}, arrow);

    if (this.painting) {

      if (arrow.target instanceof Backbone.View) {
        arrow.target = arrow.target.$el;
      } else if (arrow.target instanceof window.Element) {
        arrow.target = $(arrow.target);
      }

      if (arrow.target instanceof $) {
        offset = (step.isFixed ? arrow.target.position() : arrow.target.offset()) || {};
        offset.width = arrow.target.outerWidth();
        offset.height = arrow.target.outerHeight();
        var positions = String(arrow.position || '').trim().split(/\s+/);
        position = {
          top  : String(positions[0] || '').match(positionRegExp),
          left : String(positions[1] || '').match(positionRegExp)
        };
        var positionOffsets = {
          top  : position.top ? Number(position.top[2]) || 0 : 0,
          left : position.left ? Number(position.left[2]) || 0 : 0
        };

        position.top = position.top ? position.top[1] : 'middle';
        position.left = position.left ? position.left[1] : 'middle';

        switch (position.top) {
          case 'top':
            target.y = offset.top + positionOffsets.top;
            break;
          case 'middle':
            target.y = offset.top + (offset.height/2) + positionOffsets.top;
            break;
          case 'bottom':
            target.y = offset.top + offset.height + positionOffsets.top;
            break;
        };
        switch (position.left) {
          case 'left':
            target.x = offset.left + positionOffsets.left;
            break;
          case 'middle':
            target.x = offset.left + (offset.width/2) + positionOffsets.left;
            break;
          case 'right':
            target.x = offset.left + offset.width + positionOffsets.left;
            break;
        };
      } else if (_.isObject(arrow.target) && arrow.target.x != null && arrow.target.y != null) {
        target.x = arrow.target.x;
        target.y = arrow.target.y;
      }
    }
    return target;
  },

  updateArrows: function(options) {
    var step       = this.steps[this.activeIndex],
        self       = this,
        arrowStart = { x: 0, y: 0 };

    options = _.extend({ transition: true }, options);

    this.painting.empty();

    this._currentBounds = null;
    if (!step) { return this; }


    _.each(step.arrows, function(arrow, i) {
      var target = this.resolveArrowTarget(arrow);

      if (i === 0) {
        if (this.activeView) {
          var activeViewPosition = this.positionActiveView(step, target),
              leftSide           = target.x < (activeViewPosition.x + (activeViewPosition.width/2));
          arrowStart.x = leftSide ? (activeViewPosition.x - 50) : (activeViewPosition.x + activeViewPosition.width + 50);
          arrowStart.y = activeViewPosition.y + 20;
        } else {
          var bounds = this.bounds();
          arrowStart = CanvasUtil.Point.movePointByAngle(target, 200, CanvasUtil.Point.angleBetweenPoints(target, new CanvasUtil.Point(bounds.width/2, bounds.height/2)))
        }
      }

      var a = this.createArrow(target, arrowStart, arrow.bend || 0);
      arrowStart.y += ((Math.random() * 10) + 20);
      setTimeout(function() {
        self.painting.add(a);
      }, 200*i);
    }, this);

    if (this.activeView) { 
      var content = this.activeView.$el.parent();
      if (options.transition && $.support.transition) {
        content
          .transition({
            animation: 'fade up',
            duration: '0.3s'
          });
      } else {
        content.addClass('visible');
      }
    }
  },

  updateSpotlight: function(fn) {
    var step          = this.steps[this.activeIndex],
        pageBounds    = this.bounds(),
        self          = this,
        offsets       = null,
        hasPrevious   = this._currentBounds != null,
        currentBounds = this._currentBounds || { top: 0, left: 0, width: 0, height: 0 },
        padding       = Number(this.spotlightPadding) || 0,
        bounds        = null;

    this._currentBounds = null;

    if (!step) { return this; }

    if (step.spotlightPadding != null) {
      padding = Number(step.spotlightPadding);
    }

    function isElFixed($el) {
      while ($el.length > 0 && $el[0] !== document.body) {
        if ($el.css('position') == 'fixed') {
          return true;
        }
        $el = $el.parent();
      }
      return false;
    };

    offsets = _.map(step.spotlight, function(el) {
      var $el    = $(el),
          data   = { top: 0, left: 0, right: 0, bottom: 0, height: 0, width: 0 },
          offset = null;

      if (!step.isFixed && isElFixed($el)) {
        step.isFixed = true;
      }

      if (step.isFixed) {
        offset = $el.position();
      } else {
        offset = $el.offset();
      }

      if (!offset || !$el.is(':visible') || !$.contains(document.body, el)) {
        return null;
      }

      data.height = $el.outerHeight() || 0;
      data.width  = $el.outerWidth() || 0;
      _.extend(data, offset);
      data.bottom = data.top + data.height;
      data.right  =  data.left + data.width;
      return data;
    });

    if (step.isFixed) {
      this.$el.css('position', 'fixed');
    } else {
      this.$el.css('position', 'absolute');
    }

    bounds = _.reduce(offsets, function(memory, offset) {
      if (!memory) { return _.clone(offset); }
      if (!offset) { return memory; }

      memory.top    = Math.min(memory.top, offset.top);
      memory.left   = Math.min(memory.left, offset.left);
      memory.right  = Math.max(memory.right, offset.right);
      memory.bottom = Math.max(memory.bottom, offset.bottom);

      return memory;
    });


    // if no spotlight given then just hide them all
    if (!bounds) {
      this.ui.topSpotlight
          .hide();
      this.ui.leftSpotlight
          .hide();
      this.ui.rightSpotlight
          .hide();
      this.ui.bottomSpotlight
          .hide();

      this.ui.fullSpotlight
          .show();

      return this;
    }

    bounds.width  = bounds.right - bounds.left;
    bounds.height = bounds.bottom - bounds.top;
    
    bounds.top    = bounds.top - padding;
    bounds.left   = bounds.left - padding;
    bounds.right  = bounds.right + padding;
    bounds.bottom = bounds.bottom + padding;
    bounds.height = bounds.height + (padding * 2);
    bounds.width  = bounds.width + (padding * 2);

    this.ui.fullSpotlight
        .hide();

    var done = _.after(4, fn || function() {});

    self.ui.topSpotlight.show();
    self.ui.leftSpotlight.show();
    self.ui.bottomSpotlight.show();
    self.ui.rightSpotlight.show();

    if (!hasPrevious) {
      self.ui
          .topSpotlight
          .css('right', pageBounds.width + 'px')
      self.ui
          .leftSpotlight
          .css('right', pageBounds.width + 'px')
      self.ui
          .bottomSpotlight
          .css('right', pageBounds.width + 'px')
      self.ui
          .rightSpotlight
          .css('width', pageBounds.width + 'px')
    }
    
    _.defer(function() {
      self.ui.topSpotlight
          .css({
            height : bounds.top + 'px',
            left   : bounds.left + 'px',
            right  : (pageBounds.width - (bounds.left + bounds.width))  + 'px'
          }/*, done*/)

      self.ui.leftSpotlight
          .css({
            right: (pageBounds.width - bounds.left)  + 'px'
          }/*, done*/)
      self.ui.bottomSpotlight
          .css({
            top   : bounds.bottom + 'px',
            left  : bounds.left + 'px',
            right : (pageBounds.width - (bounds.left + bounds.width)) + 'px'
          }/*, done*/)
      self.ui.rightSpotlight
          .css({
            width: (pageBounds.width - (bounds.left + bounds.width))  + 'px'
          }/*, done*/)
      done();
    });

    this._currentBounds = bounds;

    return this;
  },

  addStep: function(step) {
    this.steps.push(_.extend({}, STEP_DEFINITION, step));
    return this;
  },

  removeAllSteps: function() {
    this.steps = [];
    return this;
  }

 });

 module.exports = Tutorial;
});
